module.exports = __webpack_public_path__ + "img/大数据企业证书.67b31d51.png";